import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/NewVuxComponents/TpDialog.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/BottomOptions.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {}, [_c(__unplugin_components_0, {
    attrs: {
      "left": _vm.bottomLeft,
      "right": _vm.bottomRight
    },
    on: {
      "on-click": _vm.onClick
    }
  }), _c('OrderMessage', {
    attrs: {
      "oid": _vm.oid
    },
    on: {
      "on-success": function ($event) {
        return _vm.$emit('on-success', 'message');
      }
    },
    model: {
      value: _vm.messageShow,
      callback: function ($$v) {
        _vm.messageShow = $$v;
      },
      expression: "messageShow"
    }
  }), _vm.isGeneralEvaluate ? _c('GeneralEvaluate', {
    attrs: {
      "oid": _vm.oid
    },
    on: {
      "on-success": function ($event) {
        return _vm.$emit('on-success', 'evaluate');
      }
    },
    model: {
      value: _vm.evaluateShow,
      callback: function ($$v) {
        _vm.evaluateShow = $$v;
      },
      expression: "evaluateShow"
    }
  }) : _vm._e(), _c(__unplugin_components_1, {
    staticClass: "refuse-Dialog",
    attrs: {
      "width": "700",
      "cancel-text": i18n.tc("11"),
      "success-text": i18n.tc("12"),
      "cancelDefaulEvent": false
    },
    on: {
      "on-cancel": function ($event) {
        _vm.showCancelOrderModal = false;
      },
      "on-success": _vm.cancelOrderSubmit
    },
    model: {
      value: _vm.showCancelOrderModal,
      callback: function ($$v) {
        _vm.showCancelOrderModal = $$v;
      },
      expression: "showCancelOrderModal"
    }
  }, [_c('div', {
    staticClass: "header font-size-h1-normal",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(i18n.tc("669"))]), _c('div', {
    staticClass: "content msg font-size-h3-normal"
  }, [_c('x-textarea', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "max": 500,
      "height": 60,
      "show-counter": true,
      "placeholder": i18n.tc("670")
    },
    model: {
      value: _vm.remark,
      callback: function ($$v) {
        _vm.remark = $$v;
      },
      expression: "remark"
    }
  })], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };